<template>
  <div class="chestionar">
    <!--  Questionnaire Card  -->
    <v-card>
      <v-form class="pa-0 ma-0" :disabled="editMode && waitResponse">
        <!--      Stats Bar       -->
        <v-row v-if="!editMode && !wrongQuestionMode && !learningMode" class="text-center stats-bar-prop text-break"
               justify="center"
               align-content="center">

          <v-col cols="2" sm="2" md="2" lg="2" align-self="center" class="text-break">
            <span class="black--text font-weight-bold">{{ initialQuestionNo }} </span>
            <span class="black--text">Intrebari Initiale</span>
          </v-col>

          <v-col cols="2" sm="2" md="2" lg="2" align-self="center" class="text-break">
            <span class="sea_orange--text font-weight-bold">{{ remainedQuestionNo }} </span>
            <span>Intrebari Ramase</span>
          </v-col>

          <v-col cols="2" sm="2" md="2" lg="2" align-self="center">

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-progress-circular mx-auto
                                     :rotate="360"
                                     :size="timerSize"
                                     :width="6"
                                     :value="progress"
                                     color="teal"
                                     v-bind="attrs"
                                     v-on="on">
                  {{ timer }}
                </v-progress-circular>
              </template>
              <span>Timpul ramas din chestionar</span>
            </v-tooltip>
          </v-col>

          <v-col cols="2" sm="2" md="2" lg="2" align-self="center" class="text-break">
            <span class="green--text font-weight-bold">{{ correctAnswers }} </span>
            <span class="black--text">Raspunsuri Corecte</span>
          </v-col>

          <v-col cols="2" sm="2" md="2" lg="2" align-self="center" class="text-break">
            <span class="red--text font-weight-bold">{{ wrongAnswers }} </span>
            <span class="black--text">Raspunsuri Gresite</span>
          </v-col>

        </v-row>

        <v-divider light class="my-3" v-if="!editMode && !wrongQuestionMode && !learningMode"></v-divider>

        <!--      Title       -->
        <v-row class="stats-bar-prop mx-5" justify="space-around" align-content="center" v-if="editMode">
          <v-col cols="12">
            <v-card flat min-height="30" min-width="30">
              <v-textarea solo
                          auto-grow v-model="question.title" rows="1" label="Titlu"
                          :rules="titleValidation" hide-details="auto">
              </v-textarea>
            </v-card>
          </v-col>
        </v-row>

        <!--      Question       -->
        <v-row class="stats-bar-prop mx-1" justify="space-around" align-content="center">
          <v-col cols="12" md="8">
            <v-card flat color="blue-grey lighten-5" min-height="30" min-width="30">
              <v-textarea class="stats-bar-prop" background-color="blue-grey lighten-5" :readonly="!editMode" solo flat
                          auto-grow v-model="question.question" rows="1"
                          :style="textSize"
                          :rules="questionValidation" hide-details="auto" label="Întrebare">
              </v-textarea>
            </v-card>

            <!--      Answers       -->
            <v-row class="text-center answers-prop py-2" justify="space-around">

              <!--        Question Image Position when it is in XS mode (e.g. mobile)     -->
              <v-col cols="12" sm="8" md="4" v-if="breakpointName === 'xs'">
                <v-img v-if="this.question.imageUrl || this.editMode"
                       :lazy-src="lazySrc"
                       :src="questionImage" ref="image" max-width="1200" max-height="400" contain aspect-ratio="1">

                  <template v-slot:placeholder>
                    <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                    >
                      <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>

                <template v-if="editMode">
                  <div>
                    <v-file-input
                        chips
                        multiple
                        prepend-icon="mdi-image"
                        label="Adauga Imagine"
                        @change="importImage"
                        v-model="chosenFileModel"
                    >
                    </v-file-input>
                  </div>
                </template>
              </v-col>

              <!--   Answers   -->
              <v-col cols="12" v-for="(answer,index) in answers"
                     :key="answer.id">
                <v-textarea class="answers-prop" :readonly="!editMode" auto-grow solo rows="2" hide-details="auto"
                            :style="textSize"
                            :background-color="answer.selector ? answer.selectedColor : ''" v-model="answer.answer"
                            @click="!wrongQuestionMode && !editMode && selectAnswer(answer.id)"
                            :rules="answerValidation" :label="'Răspuns ' + (index + 1)"
                >
                  <template #prepend>
                    <v-icon v-if="$vuetify.breakpoint.mdAndUp" color="blue" right x-large>
                      {{ answer.icon }}
                    </v-icon>
                  </template>
                  <template #append v-if="answer.showWrongIcon">
                    <v-icon color="success darken-3" right x-large>
                      {{ answer.wrongIcon }}
                    </v-icon>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <!--        Question Image Position when it is in NOT IN XS mode (e.g. mobile)     -->
          <v-col cols="12" sm="8" md="4" v-if="breakpointName !== 'xs'">
            <v-img v-if="this.question.imageUrl || this.editMode"
                   :lazy-src="lazySrc"
                   :src="questionImage" ref="image" max-width="1200" max-height="450" contain aspect-ratio="1">

              <template v-slot:placeholder>
                <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                >
                  <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <template v-if="editMode">
              <div>
                <v-file-input
                    chips
                    multiple
                    prepend-icon="mdi-image"
                    label="Adauga Imagine"
                    @change="importImage"
                    v-model="chosenFileModel"
                >
                </v-file-input>
              </div>
            </template>
          </v-col>
        </v-row>


        <!--     Answer Buttons      -->

        <v-row class="text-center stats-bar-prop px-5" justify="space-between" align-content="center"
               v-show="breakpointName !== 'xs'">
          <v-col cols="4" md="4" v-for="button in answerButtons" :key="button.id">
            <v-btn class="answer-button" :color="button.selector ? button.selectedColor : ''" x-large rounded
                   @click="!wrongQuestionMode && selectAnswer(button.id)" :disabled="editMode && waitResponse">
              <v-icon dark>
                {{ button.icon }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>


        <v-divider light class="my-3"></v-divider>
        <!--      Nav Buttons       -->

        <v-footer fixed app inset shaped color="transparent" v-if="!askQuestionMode">
          <v-row v-if="!editMode" class="text-center stats-bar-prop"
                 :justify="wrongQuestionMode || (learningMode || learningWithQuestionnaire && navButtons.length !== 2)  ? 'center' : 'space-around'"
                 align-content="center">
            <v-col
                :cols="wrongQuestionMode || (learningMode || learningWithQuestionnaire && navButtons.length === 1) ? 9 : 3"
                v-for="button in navButtons" :key="button.id">
              <v-card hover @click="performNavigationActionById(button.id)" shaped>

                <!-- LEFT ICON    -->
                <v-card-actions class="justify-center">
                  <v-icon v-if="!wrongQuestionMode &&  navButtons.length === 3"
                          :color="button.iconColor" size="50">
                    {{ button.icon }}
                  </v-icon>

                  <v-card-text class="font-weight-bold ma-0 justify-center text-no-wrap"
                               v-if="$vuetify.breakpoint.mdAndUp || wrongQuestionMode">
                    {{ button.text }}
                  </v-card-text>
                  <!-- right ICON    -->
                  <v-icon
                      v-if="wrongQuestionMode || (learningMode || learningWithQuestionnaire && navButtons.length !== 3)"
                      :color="button.iconColor" size="45">
                    {{ button.icon }}
                  </v-icon>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-footer>

        <!--     Explanation     -->
        <v-expand-transition v-if="!hideExplanation">
          <v-row v-show="visibleExplanation" class="text-center stats-bar-prop" justify="space-around"
                 align-content="center">
            <v-col cols="10">
              <v-lazy>
                <v-textarea auto-grow rows="1"
                            :class="!editMode ? showExplanation ? '' : !disableExplanationBlur ? 'explanation-hide' : '' : ''"
                            :readonly="!editMode"
                            :style="textSize"
                            outlined v-model="question.explanation" append-icon="mdi-head-question"
                            @click="explanationClicked"
                            :rules="explanationValidation">

                  <template v-slot:label>
                    <span class="font-weight-bold">Explicatie:</span>
                  </template>
                </v-textarea>
              </v-lazy>
            </v-col>
          </v-row>
        </v-expand-transition>

        <!--      Extra Data      -->
        <v-row v-if="editMode" class="mx-5">
          <v-col cols="12">
            <CategoryChooser v-model="question.category"/>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>


<script>
import CategoryChooser from "../CategoryChooser";

export default {
  name: 'Questionnaire',
  props: {
    visibleExplanation: Boolean,
    editMode: Boolean,
    wrongQuestionMode: Boolean,
    learningMode: Boolean,
    lockChoose: Boolean,
    askQuestionMode: Boolean,
    question: {
      type: Object,
      default: () => {
        return {
          "question": "Ce obligatii aveti in situatia urmatoare?",
          "answerA": "Sa nu depasiti alte vehicule.",
          "answerB": "Sa reduceti viteza.",
          "answerC": "Sa opriti la 50m de calea ferata.",
          "explanation": "Coducatorul auto este obligat sa reduca viteza la intalnirea acestui indicator. In oaras, amplasarea indicatorului se va face pe acelasi stalp cu panoul suplientar cu o dunga rosie oblica, iar in afara orasului pe panoul supmimentar cu trei dungi rosii oblice.",
          "title": "Titlu 1",
          "imageUrl": "",
          "category": "B",
          "a": true,
          "c": true,
          "b": false
        }
      }
    },
    initialQuestionNo: {type: Number, default: 26,},
    remainedQuestionNo: {type: Number, default: 5},
    correctAnswers: {type: Number, default: 3},
    wrongAnswers: {type: Number, default: 2},
    timer: {type: String, default: '20:22'},
    progress: {type: Number, default: 100},
    learningWithQuestionnaire: {type: Boolean, default: false}
  },
  components: {CategoryChooser},
  data() {
    return {
      explanationId: 0,
      disableExplanationBlur: true,
      hideExplanation: false,
      waitResponse: false,
      titleValidation: [(field) => field ? field.length > 5 || 'Titlul trebuie sa aiba cel putin 5 caractere' : true,
        (field) => field ? field.length < 50 || 'Titlul trebuie sa aiba cel mult 50 caractere' : true],
      answerValidation: [(field) => field ? field.length > 5 || 'Raspunsul trebuie sa aiba cel putin 5 caractere' : true,
        (field) => field ? field.length < 2500 || 'Raspunsul trebuie sa aiba cel mult 2500 caractere' : true],
      explanationValidation: [(field) => field ? field.length > 5 || 'Explicatia trebuie sa aiba cel putin 5 caractere' : true,
        (field) => field ? field.length < 3500 || 'Explicatia trebuie sa aiba cel mult 3500 caractere' : true],
      questionValidation: [(field) => field ? field.length > 9 || 'Explicatia trebuie sa aiba cel putin 10 caractere' : true,
        (field) => field ? field.length < 2500 || 'Explicatia trebuie sa aiba cel mult 2500 caractere' : true],
      lazySrc: "data:image/jpeg;base64,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",
      answerButtons: [
        {id: 'A', icon: 'mdi-alpha-a-box', selector: this.ASelected, selectedColor: 'green lighten-3'},
        {id: 'B', icon: 'mdi-alpha-b-box', selector: this.BSelected, selectedColor: 'green lighten-3'},
        {id: 'C', icon: 'mdi-alpha-c-box', selector: this.CSelected, selectedColor: 'green lighten-3'}
      ],
      navButtons: [
        {
          id: 'SKIP',
          text: 'Răspund mai tarziu',
          icon: 'mdi-arrow-u-left-top-bold',
          iconColor: 'yellow darken-3'

        },
        {
          id: 'DELETE',
          text: 'Sterge Răspunsul',
          icon: 'mdi-close-circle',
          iconColor: 'red darken-3',
        },
        {
          id: 'SEND',
          text: 'Trimite Răspunsul',
          icon: 'mdi-check-circle',
          iconColor: 'green darken-3'

        }
      ],
      oldNavButtons: null,
      showExplanation: false,
      chosenFile: null,
      chosenFileModel: null
    }

  },
  methods: {
    selectAnswer(answer) {

      //if the choosers are locked just stop
      if (this.lockChoose)
        return

      if (answer === 'A')
        this.ASelected = !this.ASelected;

      if (answer === 'B')
        this.BSelected = !this.BSelected;

      if (answer === 'C')
        this.CSelected = !this.CSelected;

      this.answers[0].selector = this.ASelected
      this.answers[1].selector = this.BSelected
      this.answers[2].selector = this.CSelected

      this.answerButtons[0].selector = this.ASelected
      this.answerButtons[1].selector = this.BSelected
      this.answerButtons[2].selector = this.CSelected
    },
    explanationClicked() {
      this.showExplanation = !this.showExplanation
    },
    performNavigationActionById(id) {
      if (id === 'DELETE') {
        this.answerButtons.forEach((button) => {
          button.selector = false
        });

        this.answers.forEach((button) => {
          button.selector = false
        });

        this.ASelected = false
        this.BSelected = false
        this.CSelected = false
      } else if (id === 'SEND') {
        //emit the correctness of the question
        let correctness = this.question.a === this.ASelected && this.question.b === this.BSelected && this.question.c === this.CSelected
        if (this.ASelected || this.BSelected || this.CSelected || this.wrongQuestionMode) {
          this.$emit('send', correctness)
          //do this only if we are not in the learning mode (where people still want to see how they did)
          if (!(this.learningMode || this.learningWithQuestionnaire))
            this.performNavigationActionById('DELETE')
        } else
          this.$toast.info("Selecteaza cel putin un raspuns!", '', {position: "topCenter"})
      } else if (id === 'SKIP') {
        //emit if the question was skipped
        this.performNavigationActionById('DELETE')
        this.$emit('skip', this.question.id)
      } else if (id === 'NEXT') {
        //emit if the question should be moved to the next one
        this.$emit('next')
      }
    },
    importImage(file) {
      if (!file || file.length === 0) {
        this.chosenFile = this.lazySrc
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file[0]);

      reader.onload = e => {
        this.chosenFile = e.target.result;
      }
    },
    //Retrieve question data.
    packUpQuestion(includeId = false, wrongQuestionMode = false) {

      let question = {
        question: this.question.question,
        explanation: this.question.explanation,
        a: this.ASelected,
        b: this.BSelected,
        c: this.CSelected,
        answerA: this.answers[0].answer,
        answerB: this.answers[1].answer,
        answerC: this.answers[2].answer,
        category: this.question.category,
        title: this.question.title
      }

      if (wrongQuestionMode) {
        question.imageUrl = this.question.imageUrl
        question.ACorrect = this.question.a
        question.BCorrect = this.question.b
        question.CCorrect = this.question.c
      }

      if (includeId)
        question.id = this.question.id

      return {question: question, image: this.chosenFileModel ? this.chosenFileModel[0] : null}
    },
    switchToNextButton() {
      if (this.learningMode || this.learningWithQuestionnaire) {
        if (this.navButtons.length === 2) {
          this.oldNavButtons = this.navButtons
          this.navButtons = [{
            id: 'NEXT',
            text: 'Intrebarea Urmatoare',
            icon: 'fa-arrow-right',
            iconColor: 'green darken-3'

          }]
        } else {
          this.navButtons = this.oldNavButtons
        }
      }
    },
    disableWaitResponse() {
      this.waitResponse = false
    },
    enableWaitResponse() {
      this.waitResponse = true
    },
    wrongQuestionMark() {
      //TODO: RE WRITE THIS
      if (this.wrongQuestionMode) {
        if (this.question.ACorrect)
          this.answers[0].showWrongIcon = true
        else
          this.answers[0].showWrongIcon = false
        if (this.question.BCorrect)
          this.answers[1].showWrongIcon = true
        else
          this.answers[1].showWrongIcon = false
        if (this.question.CCorrect)
          this.answers[2].showWrongIcon = true
        else
          this.answers[2].showWrongIcon = false
      } else


          //TODO: FIX THIS
      if (this.askQuestionMode || this.learningMode || this.learningWithQuestionnaire) {
        if (this.question.ACorrect || this.question.a)
          this.answers[0].showWrongIcon = true
        else
          this.answers[0].showWrongIcon = false
        if (this.question.BCorrect || this.question.b)
          this.answers[1].showWrongIcon = true
        else
          this.answers[1].showWrongIcon = false
        if (this.question.CCorrect || this.question.c)
          this.answers[2].showWrongIcon = true
        else
          this.answers[2].showWrongIcon = false
      }

    }
  },
  computed: {
    timerSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl':
          return 100
        case 'lg':
          return 85
        case 'md':
          return 75
        case 'sm':
          return 65
        case 'xs':
          return 40
        default:
          return 55
      }
    },
    textSize() {
      if (this.$vuetify.breakpoint.mdAndUp)
        return 'font-size: 1.05vmax !important'
      else return 'font-size: 2vmax !important'
    },
    breakpointName() {
      return this.$vuetify.breakpoint.name
    },
    questionImage() {
      return this.editMode ? (this.chosenFile ? this.chosenFile : this.question.imageUrl ? this.question.imageUrl : null) : this.question.imageUrl ? this.question.imageUrl : ''
    },
    answers() {
      return [
        {
          id: 'A',
          icon: 'mdi-alpha-a-box',
          selector: this.ASelected,
          answer: this.question.answerA,
          selectedColor: 'green lighten-3',
          wrongIcon: 'fa-check-circle',
          showWrongIcon: false
        },
        {
          id: 'B',
          icon: 'mdi-alpha-b-box',
          selector: this.BSelected,
          answer: this.question.answerB,
          selectedColor: 'green lighten-3',
          wrongIcon: 'fa-check-circle',
          showWrongIcon: false
        },
        {
          id: 'C',
          icon: 'mdi-alpha-c-box',
          selector: this.CSelected,
          answer: this.question.answerC,
          selectedColor: 'green lighten-3',
          wrongIcon: 'fa-check-circle',
          showWrongIcon: false
        }
      ]
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    question(newValue) {
      this.explanationId += 1
      if (newValue && newValue.explanation.substr(0, 4) === '    ')
        this.hideExplanation = true

      if (newValue)
        this.showExplanation = false

      if (this.editMode || this.wrongQuestionMode) {
        //MARK SELECTED ANSWERS
        if (this.question.a)
          this.selectAnswer('A')
        if (this.question.b)
          this.selectAnswer('B')
        if (this.question.c)
          this.selectAnswer('C')
      } else {
        this.ASelected = false
        this.BSelected = false
        this.CSelected = false
      }


      //mark the wrong questions if we are in the wrong question mode
      if (this.wrongQuestionMode)
        this.wrongQuestionMark()
    }
  },
  mounted() {
    if (this.question && this.question.explanation.substr(0, 4) === '    ')
      this.hideExplanation = true

    if (this.editMode || this.wrongQuestionMode) {
      //MARK SELECTED ANSWERS
      if (this.question.a)
        this.selectAnswer('A')
      if (this.question.b)
        this.selectAnswer('B')
      if (this.question.c)
        this.selectAnswer('C')
    } else {
      this.ASelected = false
      this.BSelected = false
      this.CSelected = false
    }

    //delete the first two navigation buttons if we are in wrongQuestionMode
    if (this.wrongQuestionMode) {
      this.navButtons.splice(0, 2)
      this.navButtons[0].text = "Intrebarea Urmatoare"
      this.navButtons[0].icon = "fa-arrow-right"
    }

    //mark the wrong questions if we are in the wrong question mode
    if (this.wrongQuestionMode)
      this.wrongQuestionMark()


    //delete the skip button if we are in learning mode
    if (this.learningMode || this.learningWithQuestionnaire) {
      this.navButtons.splice(0, 1)
    }
  }
}
</script>

<style lang="sass" scoped>
.stats-bar-prop
  font-size: 1.1vmax !important
  text-wrap: avoid
  vertical-align: middle


.answers-prop
  @extend .stats-bar-prop
  font-size: 1.05vmax !important


.answer-button
  font-size: 0.5vmax
  word-wrap: break-word
  width: 200px
  max-width: 40%

::v-deep textarea
  cursor: pointer !important

::v-deep input
  cursor: default !important

::v-deep icon
  cursor: pointer


.explanation-hide ::v-deep textarea
  filter: blur(4px) !important
  -webkit-filter: blur(4px) !important


</style>
